import {
  Box,
  Container,
  Typography,
  IconButton,
  Divider,
  Link as MuiLink,
  useTheme,
} from '@mui/material';
import { GitHub, LinkedIn, Instagram } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTiktok,
  faFacebook,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { SOCIAL_MEDIA_LINKS } from '../../utils/constants';
const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <GitHub />,
      url: SOCIAL_MEDIA_LINKS.github,
      label: 'GitHub',
    },
    {
      icon: <LinkedIn />,
      url: SOCIAL_MEDIA_LINKS.linkedin,
      label: 'LinkedIn',
    },
    {
      icon: <FontAwesomeIcon icon={faFacebook} />,
      url: SOCIAL_MEDIA_LINKS.facebook,
      label: 'Facebook',
    },
    {
      icon: <FontAwesomeIcon icon={faTiktok} />,
      url: SOCIAL_MEDIA_LINKS.tiktok,
      label: 'Tiktok',
    },
    {
      icon: <Instagram />,
      url: SOCIAL_MEDIA_LINKS.instagram,
      label: 'Instagram',
    },
    {
      icon: <FontAwesomeIcon icon={faXTwitter} />,
      url: SOCIAL_MEDIA_LINKS.x,
      label: 'X (Twitter)',
    },
  ];

  return (
    <Box
      role="contentinfo"
      sx={{
        py: 6,
        bgcolor: theme => theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        opacity: 0.99,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4,
          }}
        >
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              textDecoration: 'none',
              color: theme.palette.text.primary,
              fontWeight: 700,
              mb: { xs: 2, md: 0 },
            }}
          >
            PORTFOLIO
          </Typography>

          <Box sx={{ display: 'flex', gap: 1 }}>
            {socialLinks.map(link => (
              <IconButton
                key={link.label}
                component={MuiLink}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                color="primary"
                sx={{
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                {link.icon}
              </IconButton>
            ))}
          </Box>
        </Box>

        <Divider sx={{ mb: 4 }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: { xs: 2, sm: 0 } }}
          >
            © {currentYear} Deon Sanchez. All rights reserved.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 3,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {['Home', 'Experience', 'Projects', 'Contact'].map(
              item => (
                <MuiLink
                  key={item}
                  component={Link}
                  to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                  color="text.secondary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'primary.main',
                    },
                  }}
                >
                  {item}
                </MuiLink>
              )
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
